/* eslint-disable no-restricted-imports */
import React, {useState} from 'react'
import styles from './ActionButtons.module.scss'
import {useUIGameEndContext} from '../../../../contexts/UIGameEndContext'
import clsx from 'clsx'
import {FADE_IN_ANIMATION_DELAYS} from '../../constants'
import {FadeInContainer} from '../../../../common/FadeInContainer'
import {OpenStatsButton} from './OpenStatsButton'
import {ShareButton} from './ShareButton'
import {MapReplayButton} from './MapReplayButton'

export function ActionButtons({disableAnimation}: {disableAnimation: boolean}) {
    const {toggleEndGameScreen} = useUIGameEndContext()
    const [showOpenStatsButton, setShowOpenStatsButton] = useState(false)

    const onOpenStatsClick = () => {
        setShowOpenStatsButton(false)
        toggleEndGameScreen(true)
    }

    return (
        <>
            {showOpenStatsButton && <OpenStatsButton onOpenStatsClick={onOpenStatsClick}/>}
            <FadeInContainer
                animationDelayMs={FADE_IN_ANIMATION_DELAYS.topLeftButtons}
                animationDurationMs={FADE_IN_ANIMATION_DELAYS.transitionDuration}
                className={clsx(styles.buttonsContainer)}
                disableAnimation={disableAnimation}
            >
                <div className={styles.buttonsWrapper}>
                    <MapReplayButton setShowOpenStatsButton={setShowOpenStatsButton}/>
                    <ShareButton />
                </div>
            </FadeInContainer>
        </>
    )
}
